import { comicEntries } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";
import TagChip from "./TagChip";

export default function ComicSection() {
  return (
    <section id="comic" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="漫画改编"
          title="漂亮的小姨子漫画：从条漫到成稿的四个方向"
          desc="漫画相关的整理以“画到哪一步”“用什么形式发布”来分类，方便你按阅读习惯或查找目的各取所需。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {comicEntries.map((entry) => (
            <article
              key={entry.id}
              className="flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 transition-shadow hover:border-accent-300"
            >
              <div className="relative w-full h-[200px] md:h-[240px]">
                {entry.id === "comic-webtoon" && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Vertical%20scroll%20style%20comic%20layout%20rendered%20as%20an%20abstract%20graphic%20illustration%2C%20stacked%20panels%20in%20warm%20cream%20burgundy%20and%20amber%20tones%2C%20bold%20flat%20shapes%2C%20decorative%20roses%20in%20margins%2C%20minimal%20artistic%20poster%20composition&width=800&height=600&seq=plxdz-comic-webtoon&orientation=landscape"
                    alt="竖屏条漫版式的抽象插画，暖色调分镜排版"
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                )}
                {entry.id === "comic-boards" && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Storyboard%20sketches%20on%20cream%20paper%20styled%20as%20an%20artistic%20still%20life%2C%20graphite%20line%20frames%20and%20thumbnail%20panels%2C%20thumbnail%20roughs%2C%20pencils%20and%20markers%20scattered%20nearby%2C%20warm%20soft%20light%2C%20minimal%20editorial%20photography%20of%20a%20drawing%20desk&width=800&height=600&seq=plxdz-comic-boards&orientation=landscape"
                    alt="分镜草稿与线稿的桌面静物插画"
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                )}
                {entry.id === "comic-color" && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Finished%20colorful%20illustration%20artwork%20rendered%20as%20an%20abstract%20painterly%20scene%2C%20rich%20crimson%20amber%20and%20cream%20palette%2C%20soft%20brush%20texture%2C%20decorative%20floral%20motifs%2C%20warm%20glowing%20highlights%2C%20artistic%20gallery%20poster%20style&width=800&height=600&seq=plxdz-comic-color&orientation=landscape"
                    alt="上色完成版插画的抽象画面，暖色调笔触"
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                )}
                {entry.id === "comic-cover" && (
                  <img
                    src="https://readdy.ai/api/search-image?query=Gallery%20wall%20of%20framed%20illustrations%20styled%20as%20a%20warm%20artistic%20still%20life%2C%20golden%20frames%20with%20abstract%20paintings%2C%20cream%20walls%20with%20burgundy%20accents%2C%20soft%20evening%20lamp%20light%2C%20cozy%20editorial%20photography%20of%20a%20reading%20corner&width=800&height=600&seq=plxdz-comic-cover&orientation=landscape"
                    alt="墙上挂着插画作品的暖色图集场景"
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                )}
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-background-50/90 text-xs text-foreground-800 backdrop-blur">
                  <i className="ri-image-line"></i>
                  漫画方向
                </span>
              </div>

              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{entry.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{entry.subtitle}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">{entry.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {entry.tags.map((tag) => (
                    <TagChip key={tag} variant="accent">
                      {tag}
                    </TagChip>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}